<template>
  <div>
    <MasterLayout>
      <div class="fuel_consumption_row">
        <div
          class="card_container"
          :style="{
            backgroundImage: `url(${cardBackgroundUrl})`,
            backgroundRepeat: 'no-repeat',
            backgroundPosition: 'right',
            backgroundSize: ' 136px',
          }"
        >
          <div class="row dashboard_card">
            <div class="col-lg-6 col-md-6">
              <p>{{ $t("text.previousTrans.balance") }}</p>
            </div>
            <div class="col-lg-6 col-md-6 text-right">
              <img src="@/assets/img/wallet-grey.svg" height="40px" />
            </div>
          </div>
          <div class="dashboard_card_header_section text-center mt-4">
            <h3 class="dashboard_card_header">{{ fuelBalance }}</h3>
          </div>
        </div>

        <div
          class="fuelbalance_first_row_right_section mr-3 vr__bg"
          :style="[
            {
              backgroundImage: `linear-gradient(rgb(12, 4, 31 , 0.8), rgb(12, 4, 31 , 0.8)), url(${backgroundUrl})`,
              backgroundPosition: 'center',
              backgroundRepeat: 'no-repeat',
              backgroundSize: 'cover',
              flex: '0 0 71%',
            },
          ]"
        >
          <div class="container">
            <div class="row">
              <div class="col-md-6">
                <img
                  src="@/assets/img/Group 403 (1).png"
                  style="width: 50px; margin-top: 0px; cursor: pointer"
                  @click="changeRoute('fuelbalance')"
                  class="back_arrow_img"
                />
              </div>
              <div class="col-md-6 drop_down_input_group">
                <div class="drop_down_section mt-2 mr-2">
                  <div class="drop_down_div align-items-center">
                    <vue-ctk-date-time-picker
                      v-model="dateRange"
                      :max-date="maxDate"
                      :range="true"
                      :autoClose="true"
                      :locale="this.$root.$i18n.locale"
                      :custom-shortcuts="customShortcuts"
                      color="#4b2d73"
                      format="DDMMYYYY"
                      formatted="DD/MM/YYYY"
                      :label="$t('text.calendar.dateRange')"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="row align-items-center">
            <div class="col-md-2 text-center"></div>

            <div class="col-md-7 text-center">
              <div class="transaction_period_text text-center text-white mt-3">
                {{ $t("text.previousTrans.transBetween") }}
                {{ $d(new Date(startDate), "short", this.$root.$i18n.locale) }}
                {{ $t("text.and.text") }}
                {{ $d(new Date(endDate), "short", this.$root.$i18n.locale) }}
              </div>
            </div>
            <div class="col-md-3 text-center"></div>
          </div>
        </div>
      </div>
      <section class="section__row mt-3">
        <div class="">
          <div class=" ">
            <div class="row top_section_row mt-4" v-show="!showLoader">
              <div class="col-md-8">
                <span>
                  {{ $t("text.previousTrans.prevTransBtw") }}
                  {{
                    $d(new Date(startDate), "short", this.$root.$i18n.locale)
                  }}
                  {{ $t("text.and.text") }}
                  {{ $d(new Date(endDate), "short", this.$root.$i18n.locale) }}
                  {{ $route.query.email ? `by ${$route.query.email}` : "" }}
                </span>
                <span> </span>
              </div>
              <div class="col-md-4 text-right"></div>
            </div>
            <ejs-grid
              v-show="!showLoader"
              ref="dataGrid"
              :created="refreshGrid"
              :allowPaging="true"
              :allowSorting="true"
              :pageSettings="pageSettings"
              :toolbar="toolbar"
              :searchSettings="search"
              :allowExcelExport="true"
              :allowPdfExport="true"
              :toolbarClick="toolbarClick"
              :rowDataBound="rowDataBound"
              :excelQueryCellInfo="excelQueryCellInfo"
              :locale="usedLang"
            >
              <e-columns>
                <e-column field="index" width="40" headerText="#"></e-column>
                <e-column
                  field="date"
                  width="200"
                  :headerText="$t('text.previousTrans.date')"
                  :format="formatOptions"
                  type="date"
                ></e-column>
                <e-column
                  field="status"
                  width="120"
                  :headerText="$t('text.previousTrans.status')"
                ></e-column>
                <e-column
                  format="N2"
                  field="amount"
                  width="150"
                  textAlign="Right"
                  :headerText="$t('text.previousTrans.amount')"
                ></e-column>
                <e-column
                  field="source"
                  width="200"
                  :headerText="$t('text.previousTrans.remark')"
                ></e-column>
                <e-column
                  format="N2"
                  field="currentBalance"
                  width="150"
                  textAlign="Right"
                  :headerText="$t('text.previousTrans.currentBalance')"
                ></e-column>
              </e-columns>
            </ejs-grid>
            <TableLoader :showLoader="showLoader" />
            <div class="row mt-3 pb-5">
              <div class="col-md-3 showing_text ml-3">
                <!-- Showing 1-10 of 1000000 -->
              </div>
              <div class="col-md-8 showing_text text-right">
                <!-- Pagination -->
              </div>
            </div>
          </div>
        </div>
      </section>
    </MasterLayout>
  </div>
</template>

<script>
import MasterLayout from "@/views/Customer/MasterLayout.vue";
import backgroundUrl from "@/assets/img/danskebank.jpg";
import cardBackgroundUrl from "@/assets/img/Group393.svg";
import configObject from "@/config";
import TableLoader from "@/components/tableLoader/index";
import {
  Page,
  Sort,
  Toolbar,
  Search,
  ExcelExport,
  PdfExport,
} from "@syncfusion/ej2-vue-grids";
import JQuery from "jquery";
let $ = JQuery;

export default {
  title: "Wallet Transaction History:: Epump Portal",
  name: "DashboardHome",
  components: {
    MasterLayout,
    TableLoader,
  },
  provide: {
    grid: [Page, Sort, Toolbar, Search, ExcelExport, PdfExport],
  },
  data() {
    return {
      usedLang: this.$store.getters.getLanguage,
      formatOptions: { type: "date", format: "dd/MM/yyyy hh:mm a" },
      startDate: this.$moment().subtract(7, "days").format("MMMM D, YYYY"),
      maxDate: this.$moment(new Date()).format("YYYY-MM-DD"),
      endDate: this.$moment().format("MMMM D, YYYY"),
      pluginStartDate: this.$moment().subtract(7, "days").format("D-M-YYYY"),
      pluginEndDate: this.$moment().format("D-M-YYYY"),
      dateRange: { start: this.pluginStartDate, end: this.pluginEndDate },
      customShortcuts: [
        { key: "Today", label: this.$t("text.calendar.today"), value: "day" },
        {
          key: "yesterday",
          label: this.$t("text.calendar.yesterday"),
          value: "-day",
        },
        {
          key: "last7Days",
          label: this.$t("text.calendar.last7Days"),
          value: 7,
        },
        {
          key: "lastWeek",
          label: this.$t("text.calendar.lastWeek"),
          value: "-isoWeek",
        },
        {
          key: "last30Days",
          label: this.$t("text.calendar.last30Days"),
          value: 30,
        },
        {
          key: "lastMonth",
          label: this.$t("text.calendar.lastMonth"),
          value: "-month",
        },
      ],
      corpId: null,
      email: null,
      balance: null,
      backgroundUrl,
      cardBackgroundUrl,
      walletTransactions: null,
      fuelBalance: 0,
      showLoader: false,
      pageSettings: {
        pageSizes: [10, 20, 50, 100, 200],
        pageCount: 4,
        pageSize: 10,
      },
      toolbar: ["ExcelExport", "PdfExport", "Search"],
      search: { operator: "contains", ignoreCase: true },
    };
  },
  mounted() {
    this.corpId = this.$route.query.companyId
      ? this.$route.query.companyId
      : null;
    this.email = this.$route.query.email ? this.$route.query.email : null;
    if (!this.$route.query.balance) {
      this.getFuelBalance();
    } else {
      this.fuelBalance = this.convertThousand(
        parseFloat(this.$route.query.balance)
      );
    }
    this.getWalletTransactions();

    $(".e-input").keyup(function (e) {
      searchFun(e);
    });
    function searchFun(event) {
      var grid = document.getElementsByClassName("e-grid")[0].ej2_instances[0];
      var value = event.target.value;
      grid.search(value);
    }
  },
  watch: {
    dateRange: function (newRange, oldRange) {
      if (newRange.start !== null && newRange.end !== null) {
        this.startDate = this.$moment(newRange.start, "DD-MM-YYYY").format(
          "MMMM D, YYYY"
        );
        this.endDate = this.$moment(newRange.end, "DD-MM-YYYY").format(
          "MMMM D, YYYY"
        );

        this.getWalletTransactions();
      }
    },
    $route(to, from) {
      if (
        (from.query.email && !to.query.email) ||
        (!from.query.email && to.query.email)
      ) {
        this.email = to.query.email ? to.query.email : null;
        this.getWalletTransactions();
      }
      if (
        (from.query.companyId && !to.query.companyId) ||
        (!from.query.companyId && to.query.companyId)
      ) {
        this.corpId = to.query.companyId ? to.query.companyId : null;
        this.getFuelBalance();
        this.getWalletTransactions();
      }
    },
  },
  created() {
    this.dateRange.start = this.pluginStartDate;
    this.dateRange.end = this.pluginEndDate;
  },
  methods: {
    excelQueryCellInfo(args) {
      if (args.column.field == "date") {
        args.value = this.$moment(args.value).format("DD/MM/YYYY hh:mm A");
      }
    },
    convertThousand(request) {
      if (!isFinite(request)) {
        return "0.00";
      }
      return request
        .toFixed(2)
        .toString()
        .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
    toolbarClick(args) {
      switch (args.item.text) {
        case "PDF Export":
          let pdfExportProperties = {
            pageOrientation: "Landscape",
            fileName: "Transactions.pdf",
          };
          this.$refs.dataGrid.pdfExport(pdfExportProperties);
          break;
        case "Excel Export":
          let excelExportProperties = {
            fileName: "Transactions.xlsx",
          };
          this.$refs.dataGrid.excelExport(excelExportProperties);
          break;
      }
    },

    rowDataBound: function (args) {
      if (args.data["status"] === "Debit") {
        args.row.cells[2].style.color = "red";
      }
      if (args.data["status"] === "Credit") {
        args.row.cells[2].style.color = "green";
      }
    },
    refreshGrid() {
      if (this.$refs.dataGrid) {
        this.$refs.dataGrid.refresh();
      }
    },
    changeRoute($newRoute) {
      this.$router.push({ name: $newRoute, query: { id: this.corpId } });
    },
    showFundWalletModal() {
      this.$modal.show("fund-wallet");
    },
    getFuelBalance() {
      let url = "";
      if (this.corpId) {
        url = `${configObject.apiBaseUrl}/Wallet/Balance?id=${this.corpId}`;
      } else {
        url = `${configObject.apiBaseUrl}/Wallet/Balance?id=`;
      }
      this.axios
        .get(url, configObject.authConfig())
        .then((response) => {
          this.fuelBalance = response.data.balance
            .toFixed(2)
            .toString()
            .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        })
        .catch((error) => {});
    },
    getWalletTransactions() {
      let grid = this.$refs.dataGrid;
      this.showLoader = true;
      let url = "";
      if (this.email) {
        url = `${configObject.apiBaseUrl}/Wallet/Transactions?startDate=${this.startDate}&endDate=${this.endDate}&u=${this.email}`;
      } else if (this.corpId) {
        url = `${configObject.apiBaseUrl}/Wallet/Transactions?startDate=${this.startDate}&endDate=${this.endDate}&id=${this.corpId}`;
      } else {
        url = `${configObject.apiBaseUrl}/Wallet/Transactions?startDate=${this.startDate}&endDate=${this.endDate}`;
      }
      this.axios
        .get(url, configObject.authConfig())
        .then((response) => {
          let index = 0;
          response.data.forEach((transaction) => {
            index++;
            if (transaction.status === "Add") {
              transaction.status = "Credit";
            } else if (transaction.status === "Removal") {
              transaction.status = "Debit";
            }
            // if (transaction.amount) {
            //   transaction.amount = transaction.amount
            //     .toFixed(2)
            //     .toString()
            //     .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
            // }
            // if (transaction.currentBalance) {
            //   transaction.currentBalance = transaction.currentBalance
            //     .toFixed(2)
            //     .toString()
            //     .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
            // }
            // transaction.date = this.$moment(transaction.date).format(
            //   "DD-MM-YYYY h:mm A"
            // );
            transaction.index = index;
          });
          this.showLoader = false;
          // this.walletTransactions = response.data;
          grid.ej2Instances.setProperties({
            dataSource: response.data,
          });
          this.refreshGrid();
        })
        .catch((error) => {
          if (error.message && error.message === "Network Error") {
            this.$toast.open({
              message: "Network Error, Please Check Your Internet Connection",
              type: "error",
              duration: 5000,
            });
          } else {
            this.$toast.open({
              message: "An Error Occured",
              type: "error",
              duration: 5000,
            });
          }
        });
    },
  },
};
</script>
